import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/trip-detail/HistoryTripDetail/.eu';
import Kr from '@di-shared/features/history/trip-detail/HistoryTripDetail/.kr';
import Na from '@di-shared/features/history/trip-detail/HistoryTripDetail/.na';

export interface HistoryTripDetailProps {
  vin: string;
  tripId: string;
}

export default function HistoryTripDetail({vin, tripId}: HistoryTripDetailProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          tripId={tripId}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          tripId={tripId}
        />
      </Environment.Kr>
      <Environment.Na>
        <Na
          vin={vin}
          tripId={tripId}
        />
      </Environment.Na>
    </>
  );
}
